/* eslint-disable max-len */

export type AccommodationsInfoRes = {
  accomodation_id: number
  room_category_id: number
  room_category_id_path: string
  room_category_name: string
  /* Дефолты формы брони (KNM-136): вместимость категории и время заезда из политики объекта.
     Форма не спрашивает то, что уже задано в настройках. Время в формате HH:MM:SS. */
  person_qty: number
  extra_person_qty: number
  checkin_time: string
  checkout_time: string
  rooms: {
    room_id: number
    room_name: string
    room_category_name: string
    room_number: number | string
  }[] | null
}[]

export type ReservationFormat = {
  /** id источника из справочника; название отдельно, в source_name. */
  source: number | null
  source_name: string
  checkin_date: string
  checkin_time: string
  checkout_date: string
  checkout_time: string
  accomodation: number
  adults: number
  children: number
  contact_person: string | null
  email: string | null
  phone: string | null
  old_phone: string | null
  pk: number
  room: number | null
  room_category: number | null
  room_category_name: string | null
  status: string
  status_slug: string
  status_name: string | undefined
  notes: string | undefined
  reservation_tag: number | null
  reservation_tag_name: string | null
  reservation_tag_slug: string | null
  // Оплата: остаток к оплате (reservation_amount − paid_amount) и оплаченная сумма. Строки с бэка.
  remain_amount: string
  paid_amount: string
  cost_enabled?: boolean
}

export type ReservationsInfoRes = {
  count: number
  next: string | null
  previous: string | null
  total_pages: 1
  results: ReservationFormat[]
}
export type GetAccommodationsInfoReq = { accomodation_ids: string }
export type GetReservationsInfoReq = { accomodation_ids: string, date: string, per_page: number, page: number }

/* Один пункт справочника из метаданных OPTIONS: value — id строки в базе,
   display_name — её название оттуда же. */
export type SourceValue = { value: number, display_name: string }
export type ReservationOptionsInfoRes = {
  actions: {
    POST: {
      source: {
        choices: SourceValue[]
      }
      status: {
        choices: SourceValue[]
      }
    }
  }
}

export const GET_ACCOMMODATIONS_INFO = '/v2/pms/calendar/'
export const GET_RESERVATIONS_INFO = '/v2/pms/reservations/'

export const STATUSES = {
  notConfirmed: 'not-confirmed',
  confirmed: 'confirmed',
  stay: 'stay',
  departure: 'departure',
  reserved: 'reserved',
  cancelled: 'cancelled',
}

/* statusNumber — id строки в booking_reservationstatus: форма и API работают с ним,
   слаг нужен только внутри фронта. statusName — запасная подпись на случай, если
   метаданные OPTIONS ещё не пришли; настоящие названия берём из справочника
   (accomReservationsStore.getStatusName), там их правит миграция, а не релиз фронта. */
export const STATUS_VALUES = [
  {
    statusName: 'Не подтверждена', statusId: STATUSES.notConfirmed, statusNumber: 1,
  },
  {
    statusName: 'Подтверждена', statusId: STATUSES.confirmed, statusNumber: 2,
  },
  {
    statusName: 'Номер заселен', statusId: STATUSES.stay, statusNumber: 3,
  },
  {
    statusName: 'Номер выселен', statusId: STATUSES.departure, statusNumber: 4,
  },
  {
    statusName: 'Зарезервировано', statusId: STATUSES.reserved, statusNumber: 5,
  },
  {
    statusName: 'Отменено', statusId: STATUSES.cancelled, statusNumber: 6,
  },
]
